import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

export const store = createPinia()

// Usando o plugin de persistência
store.use(piniaPluginPersistedstate)

export default function (app) {
  app.use(store)
}